var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({staticClass:"border-none",attrs:{"label":"","outlined":"","placeholder":_vm.phtext,"tabindex":_vm.readonly ? -1 : 0}},'v-text-field',_vm.computedProps,false),_vm.computedListeners))}
var staticRenderFns = []

export { render, staticRenderFns }